// 빠른 지원 카테고리 줄 편집(시안 renderOps · openEmoji). 이모지 고르기·두 번 눌러 삭제는 화면만의 일(계약 §16).
import { useEffect, useRef, useState } from "react";
import { showToast } from "../../../utill/utill";
import { EMOJIS, mapOptions, newRow, move } from "./view";

function EmojiPicker({ anchor, current, onPick, onClose }) {
    const ref = useRef(null);
    const [pos, setPos] = useState({ left: anchor.left, top: anchor.bottom + 6 });
    useEffect(() => {
        const el = ref.current;
        const w = el?.offsetWidth || 0, h = el?.offsetHeight || 0;
        setPos({
            left: Math.max(8, Math.min(window.innerWidth - w - 8, anchor.left)),
            top: anchor.bottom + 6 + h > window.innerHeight ? anchor.top - h - 6 : anchor.bottom + 6,
        });
        const out = (e) => { if (!e.target.closest(".emopick") && !e.target.closest("[data-emo]")) onClose(); };
        const scroll = () => onClose();
        document.addEventListener("click", out);
        window.addEventListener("scroll", scroll, true);
        return () => { document.removeEventListener("click", out); window.removeEventListener("scroll", scroll, true); };
    }, [anchor, onClose]);
    return (
        <div className="emopick" ref={ref} style={{ left: pos.left, top: pos.top }}>
            {EMOJIS.map((e) => (
                <button type="button" key={e} className={current === e ? "on" : ""} onClick={() => onPick(e)}>{e}</button>
            ))}
        </div>
    );
}

export default function CategoryList({ rows, meta, onChange }) {
    const [pick, setPick] = useState(null); // { k, rect }
    const [armed, setArmed] = useState(null);
    const timer = useRef(null);
    useEffect(() => () => clearTimeout(timer.current), []);
    const opts = mapOptions(meta);

    const patch = (k, field, v) => onChange(rows.map((r) => (r._k === k ? { ...r, [field]: v } : r)));
    const del = (k) => {
        if (armed !== k) {
            setArmed(k);
            clearTimeout(timer.current);
            timer.current = setTimeout(() => setArmed(null), 3000);
            return;
        }
        clearTimeout(timer.current);
        setArmed(null);
        onChange(rows.filter((r) => r._k !== k));
        showToast("카테고리를 삭제했습니다. 저장해야 앱에 반영됩니다.", "info");
    };
    const add = () => onChange([...rows, newRow()]);
    const closePick = () => setPick(null);

    return (
        <>
            <div className="qc qc-ord hd"><span></span><span>이름</span><span>설명</span><span>이름 (中文)</span><span>설명 (中文)</span><span>접수 시 구분</span><span>순서</span><span></span></div>
            {rows.map((r, i) => (
                <div className="qc qc-ord" key={r._k}>
                    <button className="ico" type="button" data-emo={i} title="아이콘 바꾸기" aria-label="아이콘 바꾸기"
                        onClick={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setPick((p) => (p?.k === r._k ? null : { k: r._k, rect })); }}>{r.icon}</button>
                    <input className="inp" aria-label="이름" value={r.name} onChange={(e) => patch(r._k, "name", e.target.value)} />
                    <input className="inp" aria-label="설명" value={r.desc} onChange={(e) => patch(r._k, "desc", e.target.value)} />
                    <input className="inp" aria-label="이름 (中文)" value={r.nameZh} placeholder="비우면 한국어 표시" onChange={(e) => patch(r._k, "nameZh", e.target.value)} />
                    <input className="inp" aria-label="설명 (中文)" value={r.descZh} onChange={(e) => patch(r._k, "descZh", e.target.value)} />
                    <select className="sel" aria-label="접수 시 구분" value={r.map} onChange={(e) => patch(r._k, "map", e.target.value)}>
                        {r.map === "" && <option value="">구분 미지정</option>}
                        {r.map && !opts.some((o) => o.value === r.map) && <option value={r.map}>{r.map.replace("|", " · ")}</option>}
                        {opts.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </select>
                    <span className="ord">
                        <button type="button" aria-label="위로" title="위로" disabled={i === 0} onClick={() => onChange(move(rows, i, -1))}><i className="fa-solid fa-chevron-up"></i></button>
                        <button type="button" aria-label="아래로" title="아래로" disabled={i === rows.length - 1} onClick={() => onChange(move(rows, i, 1))}><i className="fa-solid fa-chevron-down"></i></button>
                    </span>
                    <button type="button" className={`del ${armed === r._k ? "armed" : ""}`} aria-label="삭제" title="삭제" onClick={() => del(r._k)}>
                        {armed === r._k ? "삭제?" : <i className="fa-regular fa-trash-can"></i>}
                    </button>
                </div>
            ))}
            <button type="button" className="addrow" onClick={add}><i className="fa-solid fa-plus"></i> 새 카테고리 추가</button>
            <div className="help" style={{ marginTop: 8 }}>카테고리명과 설명을 직접 수정할 수 있습니다. 이모지를 눌러 아이콘을 바꾸세요. 카테고리는 6개까지가 한 화면에 들어갑니다.</div>
            {pick && (
                <EmojiPicker anchor={pick.rect} current={rows.find((r) => r._k === pick.k)?.icon} onClose={closePick}
                    onPick={(e) => { patch(pick.k, "icon", e); closePick(); }} />
            )}
        </>
    );
}
